import React, { useState } from "react";
import { Dropdown } from "antd";
import { DURATION_PICKER_OPTIONS } from "../../../../constant";
import styles from "./DurationPicker.module.css";
import styled from "@emotion/styled";

const DurationPicker = () => {
  const [selectedItems, setSelectedItems] = useState(["Last 12 Months"]);

  const onClick = ({ key }) => {
    setSelectedItems([key]);
  };

  const CustomDropdown = styled(Dropdown)`
    && .ant-dropdown-menu-item-selected {
      background: transparent !important;
    }
  `;

  return (
    <div className={styles.picker_wrap}>
      Show:
      <CustomDropdown
        className={styles.dowpdown_wrap}
        menu={{
          items: DURATION_PICKER_OPTIONS,
          selectable: true,
          defaultSelectedKeys: selectedItems,
          onClick,
          className: `${styles.drop_menu} duraion-picker`,
        }}
      >
        <div className={styles.selected_option}>{selectedItems[0]}</div>
      </CustomDropdown>
    </div>
  );
};

export default DurationPicker;
